import { Role } from 'domains/models/form_user/role';
import { UserType } from 'domains/models/form_user/user_type';
import { z } from 'zod';

export const RoleEnum = z.nativeEnum(Role);
export const UserTypeEnum = z.nativeEnum(UserType);
